module.exports = __webpack_public_path__ + "static/media/menuMap.08b222d9.svg";